import type { RecipientKeyDirectoryItem } from "../api/e2eeKeys";
import { getRecipientKeys } from "./recipientKeyCache";

export type ResolvedRecipientKey = RecipientKeyDirectoryItem;

export async function resolveRecipientPublicKeys(recipientUserIds: string[]): Promise<ResolvedRecipientKey[]> {
  return getRecipientKeys(recipientUserIds);
}
